import type { Event } from "@apps/gwservice/types"
import { formatEventDate, formatEventTimeRange } from "~/lib/utils"

interface EventCardProps {
  event: Event
  onClick: () => void
}

export function EventCard({ event, onClick }: EventCardProps) {
  const date = formatEventDate(event.date)
  const timeRange = formatEventTimeRange(event.date, event.endTime)

  return (
    <div onClick={onClick} className="bg-primary/10 rounded-md p-s size-event-card shrink-0 ml-m flex flex-col cursor-pointer">
      <div lang="ru" className="line-clamp-3 leading-tight hyphens-auto">{event.title}</div>
      <div className="text-[13px] leading-tight mt-auto">
        <div className="truncate text-secondary">{event.group?.name ?? "<УДАЛЕНО>"}</div>
        <span className="text-muted-foreground truncate">{date} {timeRange}</span>
      </div>
    </div>
  )
}
